import { useLocalizedStrings } from 'i18n';

import { MonitoringDataType } from '../identityMonitoring.types';

/**
 * Helper that returns localized strings for all data types.
 */
export const useMonitoringDataTypeNames = (): Record<MonitoringDataType, string> => {
  // i18next-extract-mark-ns-start identity
  const { t } = useLocalizedStrings('identity');

  return {
    EmailAddress: t('IdentityType.EmailAddress'),
    TelephoneNumber: t('IdentityType.TelephoneNumber'),
    MedicalID: t('IdentityType.MedicalID'),
    DriverLicense: t('IdentityType.DriverLicense'),
    Iban: t('IdentityType.Iban'),
    OtherCard: t('IdentityType.OtherCard'),
    Passport: t('IdentityType.Passport'),
    NationalId: t('IdentityType.NationalId'),
    BankAccount: t('IdentityType.BankAccount'),
    CreditCard: t('IdentityType.CreditCard'),
    DebitCard: t('IdentityType.DebitCard'),
    SSN: t('IdentityType.SSN'),
  };
  // i18next-extract-mark-ns-stop identity
};

export const useMonitoringDataTypeName = (dataType: MonitoringDataType): string => useMonitoringDataTypeNames()[dataType];
